/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import { apinoticedetail } from '@/api';
export default {
  name: 'NoticeDetail',
  props: {
    id: Number
  },
  data: function data() {
    return {
      info: {}
    };
  },
  components: {
    ViewBox: ViewBox
  },
  methods: {},
  created: function created() {
    var _this = this;
    apinoticedetail({
      id: this.id
    }).then(function (res) {
      if (res.success) {
        _this.info = res.data;
      }
    });
  }
};